import {
  CheckOutlined,
  DownOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  ProfileOutlined,
  CloseSquareOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Flex,
  Image,
  Select,
  Space,
  Tag,
  Tooltip,
  Typography,
  theme,
} from "antd";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUserContext } from "../../contexts/UserContext";
import Dropdown from "../dropdown/Dropdown";
import CustomTags from "../tag/CustomTags";
import brokenImage from "../../assets/broken-image 2.png";
import { ReactComponent as TickMark } from "../../assets/status-tag-icons/tick-square.svg";
import { ReactComponent as Clock } from "../../assets/status-tag-icons/clock.svg";
import { ReactComponent as Cross } from "../../assets/status-tag-icons/cross-square.svg";

const CompanyCard = ({ companyData, readinessIndexType, icon }) => {
  const {
    id,
    companyName,
    companyImage,
    industry,
    strength,
    isEvaluated,
    evaluationInProgress,
    evaluationDetails,
  } = companyData;
  const navigate = useNavigate();
  const { role } = useUserContext();
  const { consultantId } = useParams();

  const companyStatus = evaluationDetails[readinessIndexType].status;

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  // const handleCardClick = (event) => {
  //   navigate('pfizer')
  // }

  const handleButtonClick = (event) => {
    event.stopPropagation();
    navigate(
      companyStatus === 2
        ? `/company/${id}/questionnaire/${readinessIndexType}/review`
        : `/company/${id}/questionnaire/${readinessIndexType}`
    );
  };

  const imageContainter = {
    borderBottom: "2px solid #D7E3F1",
    borderRadius: "25px",
    boxShadow: " 0px 5px 15px 0px #0000000D",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "207px",
  }

  return (
    // <Card hoverable style={{ cursor: "default" , border:"2px solid #D7E3F1" , borderRadius:"25px", padding:"0px"}}>
    <div
      style={{
        cursor: "default",
        border: "2px solid #D7E3F1",
        borderRadius: "25px",
        padding: "0px",
      }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        {
          companyImage ? (
            <Flex justify="center">
              <div
                style={
                  imageContainter
                }
              >
                <Image
                  src={companyImage}
                  style={{ height:'150px',width: "100%", background:'none'}}
                />
              </div>
            </Flex>
          ) : (
            // <Flex justify="center" align="center">
            <div
              style={imageContainter}
            >
              <img src={brokenImage} alt="" />
            </div>
            // </Flex>
          )
          // <div style={{ width: '100%', height: '150px', backgroundColor: 'rgb(200, 200, 200)', borderRadius: '6px' }}>{icon}</div>
        }
        <Flex justify="center" style={{ marginTop: "-30px" }}>
          {/* --------------custom tags starts-------- */}
          {companyStatus === 2 ? (
            <CustomTags
              icon={<TickMark />}
              tagText="Evaluation Completed"
              backgroundColor="#18CAD8"
            />
          ) : companyStatus === 1 ? (
            <CustomTags
              icon={<Clock />}
              tagText={"Evaluation in progress"}
              backgroundColor={"#F2C041"}
            />
          ) : (
            <CustomTags
              icon={<Cross />}
              tagText={"Evaluation Not Started"}
              backgroundColor={"#D84848"}
            />
          )}
          {/* --------------custom tags end-------- */}
        </Flex>
        <div style={{ margin: "20px 18px 30px 18px" }}>
          <Flex
            justify="center"
            style={{
              width: "100%",
              marginTop: 16,
            }}
          >
            <Typography.Title level={3} style={{ marginTop: "0" }}>
              {companyName}
            </Typography.Title>
          </Flex>

          <Flex justify="space-between" style={{}}>
            <Flex vertical={true} gap={8} align="flex-start">
              <Typography.Text
                style={{
                  fontWeight: "400",
                  fontSize: "16px",
                  color: "#07224D",
                }}
              >
                Industry:
              </Typography.Text>
              <Typography.Text
                style={{
                  fontWeight: "400",
                  color: "#92A7BE",
                  fontSize: "16px",
                }}
              >
                {industry}
              </Typography.Text>
            </Flex>
            <Flex vertical={true} align="flex-end">
              <Typography.Text
                style={{
                  fontWeight: "400",
                  fontSize: "16px",
                  color: "#07224D",
                }}
              >
                Strength:
              </Typography.Text>
              <Typography.Text
                style={{
                  fontWeight: "400",
                  color: "#92A7BE",
                  fontSize: "16px",
                }}
              >
                {strength}
              </Typography.Text>
            </Flex>
          </Flex>

          {/* {role === 'consultant' && <Button type="default"  icon={<FileSearchOutlined />} onClick={handleButtonClick}>{evaluationDetails[readinessIndexType].status === 2 ? 'Review' : 'Questionnaire'}</Button>}
          {(role === 'admin' && evaluationDetails[readinessIndexType].status === 2) && <Button type="default"  icon={<FileSearchOutlined />} onClick={() => navigate(`/consultant/${consultantId}/company/${id}/questionnaire/${readinessIndexType}/review`)}>Review</Button>}
          
          <Button type="default" icon={<ProfileOutlined />} onClick={() => navigate(role === 'consultant' ? `/company/${id}/${readinessIndexType}` : `/consultant/${consultantId}/company/${id}/${readinessIndexType}`)}>Details</Button> */}
          <Flex gap={20} style={{ marginTop: 20 }}>
            {role === "consultant" && (
              <>
                <Button
                  type="default"
                  icon={<FileSearchOutlined />}
                  onClick={handleButtonClick}
                  style={{
                    color: " #3BA4FE",
                    border: "1px solid #3BA4FE",
                    // padding: "15.5px, 41px, 15.5px, 41px",
                    // width:"150px",
                    width: "50%",
                    height: "49px",
                    borderRadius: 10,
                  }}
                >
                  {evaluationDetails[readinessIndexType].status === 2
                    ? "Review"
                    : "Questionnaire"}
                </Button>
                <Button
                  style={{
                    backgroundColor: "#3BA4FE",
                    // width: "150px",
                    width: "50%",
                    height: "49px",
                    // padding: "15.5px 41px 15.5px 41px",
                    color: "white",
                    borderRadius: 10,
                  }}
                  type="default"
                  icon={<ProfileOutlined />}
                  onClick={() => navigate(`/company/${id}`)}
                >
                  View Details
                </Button>
              </>
            )}
            {role === "admin" &&
            evaluationDetails[readinessIndexType].status === 2 ? (
              <>
                <Button
                  type="default"
                  icon={<FileSearchOutlined />}
                  style={{
                    color: " #3BA4FE",
                    border: "1px solid #3BA4FE",
                    // padding: "15.5px, 41px, 15.5px, 41px",
                    // width:"150px",
                    width: "50%",
                    height: "49px",
                    borderRadius: 10,
                  }}
                  onClick={() =>
                    navigate(
                      `/consultant/${consultantId}/company/${id}/questionnaire/${readinessIndexType}/review`
                    )
                  }
                >
                  Review
                </Button>
                <Button
                  style={{
                    backgroundColor: "#3BA4FE",
                    // width: "294px",
                    width: "50%",
                    height: "49px",
                    padding: "15.5px, 41px, 15.5px, 41px",
                    color: "white",
                    borderRadius: 10,
                  }}
                  type="default"
                  icon={<ProfileOutlined />}
                  onClick={() =>
                    navigate(`/consultant/${consultantId}/company/${id}`)
                  }
                >
                  View Details
                </Button>
              </>
            ) : role === "admin" &&
              (evaluationDetails[readinessIndexType].status === 0 ||
                evaluationDetails[readinessIndexType].status === 1) ? (
              <Button
                style={{
                  backgroundColor: "#3BA4FE",
                  // width: "294px",
                  height: "49px",
                  padding: "15.5px, 41px, 15.5px, 41px",
                  color: "white",
                  width: "100%",
                  borderRadius: 10,
                }}
                type="default"
                icon={<ProfileOutlined />}
                onClick={() =>
                  navigate(
                    `/consultant/${consultantId}/company/${id}`
                  )
                }
              >
                View Details
              </Button>
            ) : null}
          </Flex>
        </div>
      </Space>
    </div>
  );
};

export default CompanyCard;
